import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderText from '../../Common/HeaderText';
import ResumeRow from '../../../JobBoard/Apply/ResumeRow';
import { BaseButton, useIsMobile } from '@repo/common';

import { ReactComponent as ArrowIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-right.svg';
import { getStandardCareer } from '../../../../api/career/career.api';

const Resumes = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [resume, setResume] = useState(null);

  useEffect(() => {
    const fetchStandardResume = async () => {
      try {
        const data = await getStandardCareer();
        setResume(data);
      } catch (error) {
        console.error('Failed to fetch standard resume', error);
      }
    };

    fetchStandardResume();
  }, []);

  return (
    <div className='flex flex-col max-w-[868px] w-full items-start tabletH:pb-6'>
      <HeaderText label={'Resumes'} />
      <div className='flex flex-col gap-2 w-full'>
        <ResumeRow
          status={'view'}
          resume={resume}
          isMyPage
          $isMobile={isMobile}
        />
        <BaseButton
          type='text_basic'
          size='l'
          iconPosition='after'
          icon={<ArrowIcon />}
          onClick={() => navigate('/mypage/resumes/all')}
        >
          View all resumes
        </BaseButton>
      </div>
    </div>
  );
};

export default Resumes;
